import { useEffect, useRef } from "react";
import { mountOrbitalSphere } from "./OrbitalSphere";

export function OrbitalSphereBackground({ className = "", ...options }) {
  const hostRef = useRef(null);
  const instanceRef = useRef(null);

  useEffect(() => {
    const instance = mountOrbitalSphere(hostRef.current, options);
    instanceRef.current = instance;
    return () => {
      instance.destroy();
      instanceRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Новые пропсы (speed, hue, scale…) применяются без пересоздания сцены.
  useEffect(() => {
    instanceRef.current?.update(options);
  });

  return (
    <div
      ref={hostRef}
      aria-hidden="true"
      className={`bg-container ${className}`.trim()}
    />
  );
}

export default OrbitalSphereBackground;
